import { render, staticRenderFns } from "./BaseSideModal.vue?vue&type=template&id=054c0eff&scoped=true&"
import script from "./BaseSideModal.vue?vue&type=script&lang=js&"
export * from "./BaseSideModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseSideModal.vue?vue&type=style&index=0&id=054c0eff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c0eff",
  null
  
)

export default component.exports